<template>
  <div>
    <label class="typo__label">Areas of Interest</label>
    <multiselect
      v-model="areas"
      :options="availableAreas"
      :multiple="true"
      group-values="items"
      group-label="name"
      :group-select="true"
      placeholder="Search or add area"
      :taggable="true"
      @tag="addArea"
      tag-placeholder="Add this as new area"
    >
      <span slot="noResult">(no areas found)</span>
    </multiselect>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      areas: [],
      availableAreas: [
        {
          name: "Formal sciences",
          items: [
            "Computer sciences",
            "Logic",
            "Mathematics",
            "Systems science"
          ]
        },
        {
          name: "Humanities",
          items: [
            "Anthropology",
            "History",
            "Linguistics and languages",
            "Philosophy",
            "Religion",
            "The arts"
          ]
        },
        {
          name: "Natural sciences",
          items: [
            "Biology",
            "Chemistry",
            "Earth sciences",
            "Physics",
            "Space sciences"
          ]
        },
        {
          name: "Professions and applied sciences",
          items: [
            "Agriculture",
            "Architecture and design",
            "Business",
            "Divinity",
            "Education",
            "Engineering and technology",
            "Environmental studies and forestry",
            "Family and consumer science",
            "Human physical performance and recreation",
            "Journalism, media studies and communication",
            "Law",
            "Library and museum studies",
            "Medicine",
            "Military sciences",
            "Public administration",
            "Social work",
            "Transportation"
          ]
        },
        {
          name: "Social sciences",
          items: [
            "Economics",
            "Geography",
            "Political Science",
            "Psychology",
            "Sociology"
          ]
        }
      ]
    };
  },
  methods: {
    handleInput() {
      this.$emit("input", this.selectedAreas);
    },
    addArea(item) {
      var name = this.areas.find(function(entry) {
        entry.name === "Other";
      });

      if (!name) {
        name = {
          name: "Other",
          items: []
        };

        this.availableAreas.push(name);
      }

      name.items.push(item);
      this.areas.push(item);
    }
  }
};
</script>